import { useTypedQuery } from "hooks";
import { TyreGroupQueryKeys } from "modules/AppointmentDetails/components/VehicleTyres/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerLocation } from "models";

export type TyreSearchRequest = {
  height: number | null;
  dealer_location_id: number;
  manufacturer: string | null;
  season: number | null;
  size: number | null;
  width: number | null;
  in_stock?: boolean;
  tyre_team_delivery_ids?: string[];
};

export const useReplacementTyreSearch = (searchRequest: TyreSearchRequest, location: DealerLocation | undefined) => {
  let queryKey = TyreGroupQueryKeys.claireTyreSearchResults;
  if (location?.is_tyre_team_enabled) queryKey = TyreGroupQueryKeys.tyreTeamSearchResults;
  else if (location?.is_tyre_net_enabled) queryKey = TyreGroupQueryKeys.tyreNetSearchResults;

  const query = useTypedQuery({
    queryKey,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, searchRequest, baseUrl)).data.tyres ?? [],
    enabled: false
  });

  return {
    searchReplacementTyres: query.refetch,
    isSearchReplacementTyresFetching: query.isFetching
  };
};
